<template>
  <v-bottom-sheet
    v-model="isOpen"
    rounded="xl b-0"
    inset
    :max-width="maxAppWidth"
  >
    <v-sheet class="px-4 py-6" rounded="xl b-0">
      <div class="d-flex flex-row align-center justify-space-between pb-4">
        <span class="tp-text-subtitle-semibold">
          {{ $t('components.localeSelector.automaticTranslations.title') }}
        </span>
        <img
          :src="require(`@/assets/images/icons/chevron-down-white-icon.svg`)"
          @click="close"
        />
      </div>
      <div class="tp-text-body-gray">
        {{ $t('components.localeSelector.automaticTranslations.subtitle') }}
      </div>
      <v-list flat class="pt-6">
        <v-list-item-group color="black">
          <template v-for="(language, key) in availableLanguages">
            <v-list-item
              :key="`locale-${key}`"
              class="pa-0"
              :ripple="false"
              :data-cy="`language-selector-option-${language.code}`"
              @click="changeLanguage(language)"
            >
              <v-list-item-icon class="mr-2">
                <img :src="language.image" style="width: 22px" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="tp-text-body-2"
                  v-text="language.name"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mr-0">
                <v-checkbox
                  color="black"
                  class="mr-0"
                  :ripple="false"
                  :input-value="selectedLanguage === language.code"
                ></v-checkbox>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { languages } from '@/utils/languages';

export default {
  props: {
    languageList: {
      type: Array,
      default: () => [],
    },
    selectedLanguage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      languages,
    };
  },
  computed: {
    availableLanguages() {
      return this.languages.filter(language =>
        this.languageList.includes(language.code)
      );
    },
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    },
    async changeLanguage(language) {
      this.close();
      this.$emit('changeLanguage', language);
    },
  },
};
</script>

<style lang="scss">
.locale-selector {
  &__translations-disclaimer {
    color: $color-dark;
  }
}

.locale-selector-translations-disclaimer {
  &__subtitle {
    color: $color-gray;
  }
}
</style>
